import React, { useEffect, useState } from "react";
import { CircularProgress, Grid } from "@material-ui/core";
import { useIntl } from "react-intl";
import { BackButton, ButtonSubmit, Container, Panel } from "../../../../Components";
import { TextField2 } from "../../../../Components/Field";
import { SelectDropDown } from "../../../../Components/Select/SelectDropDown";
import { useStyles } from "./Document.styles";
import { FileUpload, FileUploadProps } from "./FileUpload";
import { FileTypes } from "./FileTypes";
import CustomerServicesApi from "../../../../Redux/Actions/CustomerAction";
import { useDispatch, useSelector } from "react-redux";
import { useApiValidationSnackbar } from "../../../../Components/Snackbar/SnackbarAlert";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateDocument } from "../DocumentGroup/DocumentGroup/CreateDocument";
import DocumentGroupServices from "../../../../Redux/Actions/DocumentGroup/DocumentGroupAction";
import { useSnackbar } from "notistack";
import DropDownItem from "./DropDownItem";
import Select from '@material-ui/core/Select';
import { Loading } from '../../../../Components/Loader/Loading';
require("./styles.css");
type uploadProps = {
    DocumentGroupId?: any;
    Name: string;
    File: any;
};

export const UploadMultipleDocument = () => {
    const {
        apiToken,
        currentUser,
        uploadData,
        allDocumentsGroup,
        treeStructureDocument,
    } = useSelector((state: any) => ({
        apiToken: state?.UserReducer?.apiToken,
        currentUser: state?.UserReducer?.currentUser,
        uploadData: state?.CustomerReducer?.uploadData,
        allDocumentsGroup: state?.DocumentGroupReducer?.allDocumentsGroup||[],
        treeStructureDocument: state?.DocumentGroupReducer?.treeStructureDocument,
    }));
    const { formatMessage } = useIntl();
    let addGroup = [
        {
            id: 0,
            name: formatMessage({
                id: "document.upload.addGroup",
                defaultMessage: "Add group",
            }),
            description: "",
        },
        // {
        //   id: -1,
        //   name: formatMessage({
        //     id: "document.upload.removerDocument",
        //     defaultMessage: "Remove document group",
        //   }),
        //   description: "",
        // },
    ];
    let [select, setSelect] = useState<any>([]);
    const [fileName, setFileName] = useState<uploadProps>();
    const [reload, setReload] = useState(false);
    let [selected, setSelected] = useState<any>("");
    const [file, setFile] = useState<any>([]);
    const [open, setOpen] = useState(false);
    const [selectValue, setSelectValue] = useState({ id: "", name: "" });
    const classes = useStyles();
    const dispatch: any = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { notifySuccess, ErrorMessage } = useApiValidationSnackbar();
    const navigate = useNavigate();
    const users = useLocation().state?.rowData;
    let [checked, setChecked] = React.useState(false);
    let [specificBinder, setSpecificBinder] = useState<any>("")
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        hierarchicalDocumentFunction();
    }, []);
    const hierarchicalDocumentFunction = () => {
        let customerId = currentUser?.customerId;
        dispatch(DocumentGroupServices.documentHierarchical(customerId, apiToken));
    };
    const fileUploadProp: FileUploadProps = {
        accept: "file/*",
        multiple: true,
        onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
            let fileList: any = event?.target?.files
            let fileListinArray: any = Array.from(fileList)
            setFile(fileListinArray)
            let SelectList = fileListinArray?.map((val: any) => {
                return {
                    File: val,
                    Name: val?.name,
                    DocumentGroup: { id: "", name: "" },
                }
            })
            setSelect(SelectList)
        },
        onDrop: (event: React.DragEvent<HTMLElement>) => {
            let fileList: any = event?.dataTransfer?.files
            let fileListinArray: any = Array.from(fileList)
            setFile(fileListinArray)
            let SelectList = fileListinArray?.map((val: any) => {
                return {
                    File: val,
                    Name: val?.name,
                    DocumentGroup: { id: "", name: "" },
                }
            })
            setSelect(SelectList)
        },
    };

    // const fileUpload = async () => {
    //     let uploadkey: any = "uploadFile";
    //     let fileNamekey: any = "fileName";
    //     let data = [...select]
    //     if (data?.length == 0) {
    //         return ErrorMessage(file, uploadkey);
    //     }
    //     let count = 0
    //     data.forEach((element: any) => {
    //         if (!element?.Name) {
    //             count += 1
    //         }
    //     })
    //     if (count > 0) {
    //         return ErrorMessage(file, fileNamekey);
    //     }

    //     const customerId = currentUser?.customerId;
    //     if (specificBinder == 'yes') {

    //         data?.forEach(async (item: any) => {
    //             let formData = {
    //                 File: item?.File,
    //                 Name: item?.Name,
    //                 DocumentGroupId: Number(selected),
    //             }
    //             await dispatch(
    //                 CustomerServicesApi.uploadFile(
    //                     formData,
    //                     customerId,
    //                     apiToken,
    //                     notifySuccess,
    //                     enqueueSnackbar
    //                 )
    //             );
    //         })
    //     } else {
    //         data?.forEach(async (item: any) => {
    //             let formData = {
    //                 File: item?.File,
    //                 Name: item?.Name,
    //                 DocumentGroupId: Number(item?.DocumentGroup?.id),
    //             }
    //             await dispatch(
    //                 CustomerServicesApi.uploadFile(
    //                     formData,
    //                     customerId,
    //                     apiToken,
    //                     notifySuccess,
    //                     enqueueSnackbar
    //                 )
    //             );
    //         })
    //     }
    //     await fileuploadReload()
    // };

    const fileUpload = async () => {
        const uploadkey: any = "uploadFile";
        const fileNamekey: any = "fileName";

        // Check if data array is empty
        if (!select.length) {
            return ErrorMessage(file, uploadkey);
        }

        let count = 0;
        select.forEach((element: any) => {
            if (!element?.Name) {
                count++;
            }
        });

        // Check if any element has missing Name
        if (count > 0) {
            return ErrorMessage(file, fileNamekey);
        }

        const customerId = currentUser?.customerId;
        const groupId = specificBinder === 'yes' ? Number(selected) : null;
        // Prepare formData and dispatch uploadFile for each item
        setLoading(true)
        for (let item of select) {
            const formData = {
                File: item?.File,
                Name: item?.Name,
                DocumentGroupId: groupId || Number(item?.DocumentGroup?.id),
            };

            try {
                await dispatch(
                    CustomerServicesApi.uploadFile(
                        formData,
                        customerId,
                        apiToken,
                        notifySuccess,
                        enqueueSnackbar
                    )
                );
            } catch (error) {
                console.error('Error uploading file:', error);
                // Handle error as needed
            }

            // Delay for 1 second before processing the next item
            await delayExecution(500); 
        }

        // Reload after all files are uploaded
        setLoading(false)
        await fileuploadReload();
    };

    function delayExecution(delay) {
        return new Promise(resolve => {
            setTimeout(resolve, delay);
        });
    }

    const fileuploadReload = () => {
        const customerId = currentUser?.customerId;
        let isArchive = false
        if (uploadData) {
            navigate("/ms/administrations/documents");
            dispatch(
                CustomerServicesApi.getAllDocuments(
                    customerId,
                    currentUser?.id,
                    apiToken,
                    isArchive
                )
            );
        }
    };
    const cancelButton = () => {
        setFile(null);
        // const formData = {
        //     file: "",
        //     description: "",
        //     name: "",
        // };
        setSelect([]);
        navigate("/ms/administrations/documents");
    };


    const closeBox = () => {
        setOpen(false);
    };
    const reloadTable = () => {
        dispatch(
            DocumentGroupServices.allDocumentGroups(currentUser?.customerId, apiToken)
        );
        const success: any = "download";
        notifySuccess(allDocumentsGroup, success);
        setReload(false);
    };
    const setReloadTable = () => {
        setReload(true);
    };
    let userPth = {
        id: users?.id,
        documents: "document",
    };
    return (
        <div className="UploadDocument-form-page">
            {loading ?
                <div style={{ width: '100%', height: "70vh", display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                    <span>{formatMessage({ id: 'document.upload.documents.loadingtext' })} </span>
                </div>
                :
                <Container fullWidth>
                    <Grid container justifyContent="flex-start">
                        <BackButton link={"/ms/administrations/documents"} />
                    </Grid>
                    <Panel>
                        <Grid
                            item
                            xs={4}
                            className={`${classes.marginTop15} uploadDocument-btn`}
                        >
                            <FileUpload {...fileUploadProp} />
                        </Grid>
                        {file?.length > 0 && <span>{file?.length} {formatMessage({ id: "upload.select.item.text", defaultMessage: "Document selected" })}</span>}
                        {file?.length && specificBinder == "" ? <Grid
                            className={`${classes.marginTop15} ${classes.documentquestion} uploadDocument-input-field`}>
                            {formatMessage({
                                id: "document.upload.binder.question",
                                defaultMessage: "Would you like to upload all the documents to one specific folder or different folders?",
                            })}
                            {/* <span onClick={() => setSpecificBinder('yes')} className={`${classes.textbtn} ${specificBinder === 'yes' && classes.selected}`}>  {formatMessage({
                            id: "form.specificfolder",
                            defaultMessage: "One specific folder",
                        })} </span> */}
                            <ButtonSubmit text={"form.specificfolder"} onClick={() => setSpecificBinder('yes')} />
                            /
                            <ButtonSubmit text={"form.differentfolder"} onClick={() => setSpecificBinder('no')} />
                            {/* <span onClick={() => setSpecificBinder('no')} className={`${classes.textbtn} ${specificBinder === 'no' && classes.selected}`}> {formatMessage({
                            id: "form.differentfolder",
                            defaultMessage: "Different folders",
                        })} </span> */}

                            {/* <span onClick={() => setSpecificBinder('no')} className={classes.skip}>   {formatMessage({
                            id: "form.skip",
                            defaultMessage: "Skip",
                        })}</span> */}
                        </Grid> : ""}
                        {specificBinder == "yes" && <Grid
                            className={`${classes.marginTop15} uploadDocument-input-field`}>
                            <Grid
                                item
                                xs={4}
                                style={{ paddingRight: "10px" }}
                                className="dropdownItemField"
                            >
                                <DropDownItem
                                    data={[...addGroup, ...allDocumentsGroup]}
                                    restrict={checked}
                                    handleChange={(val) => {
                                        let selecValue = val?.id;
                                        if (selecValue == 0) {
                                            setOpen(true);
                                        } else {
                                            setSelected(selecValue);
                                            setSelectValue(val);
                                        }
                                    }}
                                    selectValue={selectValue}
                                />
                            </Grid>
                        </Grid>}
                        <Grid container>
                            {
                                specificBinder !== "" && select?.map((item: any, index) => {
                                    return (
                                        <Grid
                                            container
                                            spacing={2}
                                            className={`${classes.marginTop15} uploadDocument-input-field`}
                                        >
                                            <Grid item xs={4}>
                                                <TextField2
                                                    onChange={(str: string) => {
                                                        let data: any = [...select]
                                                        data[index] = { ...data[index], Name: str }
                                                        setSelect(data)
                                                    }
                                                    }
                                                    placeholder={formatMessage({
                                                        id: "document.upload.fileName",
                                                        defaultMessage: "File name",
                                                    })}
                                                    value={item?.Name}
                                                    Textlabel="user.edit.name"
                                                />
                                            </Grid>
                                            {specificBinder == "no" && <Grid
                                                item
                                                xs={4}
                                                style={{ paddingRight: "10px" }}
                                                className="dropdownItemField"
                                            >
                                                <DropDownItem
                                                    data={[...addGroup, ...allDocumentsGroup]}
                                                    restrict={checked}
                                                    handleChange={(val) => {
                                                        let selecValue = val?.id;
                                                        if (selecValue == 0) {
                                                            setOpen(true);
                                                        } else {
                                                            // setSelect({ ...select, userName: selecValue });
                                                            // setSelected(selecValue);
                                                            // setSelectValue(val);
                                                            let data: any = [...select]
                                                            data[index] = { ...data[index], DocumentGroup: val }
                                                            setSelect(data);
                                                        }
                                                    }}
                                                    selectValue={item?.DocumentGroup}
                                                />
                                            </Grid>}
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                        <Grid
                            container
                            justifyContent="space-between"
                            className={classes.marginTop15}
                        >
                            <ButtonSubmit text={"model.title.cancel"} onClick={cancelButton} />
                            <ButtonSubmit text={"document.upload"} onClick={fileUpload} />
                        </Grid>
                        <CreateDocument
                            handleClose={closeBox}
                            open={open}
                            group={undefined}
                            documentData={userPth}
                            forceReload={reloadTable}
                            setReload={setReloadTable}
                            hierarchicalDocumentFunction={() => hierarchicalDocumentFunction()}
                            data={treeStructureDocument}
                        />
                    </Panel>
                </Container>
            }
        </div>
    );
};
